import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import { BRAND } from "@/config/brand";
import { TESTIDS } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={TESTIDS.footer.root}
      className="relative bg-black text-white pt-24 pb-10 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-14 pb-16 border-b border-white/10">
          <div className="lg:col-span-5">
            <img
              src={BRAND.logo}
              alt="Vasquez & Son Construction Inc."
              className="h-24 w-24 object-contain mb-6"
            />
            <div className="font-display uppercase text-2xl md:text-3xl tracking-tight leading-tight max-w-md">
              <span className="chrome-text">Building Long Island,</span>
              <br />
              <span className="text-[color:var(--vs-blue)]">one home at a time.</span>
            </div>
            <p className="mt-5 text-sm text-gray-400 max-w-md leading-relaxed">
              Family-owned home improvement contractor. Fully licensed and insured. Serving Nassau and Suffolk counties for over two decades.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40 mb-5">
              Services
            </div>
            <ul className="space-y-3 text-sm">
              {BRAND.services.map((s) => (
                <li key={s.key}>
                  <a href="#services" className="text-white/80 hover:text-[color:var(--vs-blue)] transition-colors font-display uppercase tracking-tight">
                    {s.key}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-white/40 mb-5">
              Contact
            </div>
            <ul className="space-y-4 text-sm">
              <li>
                <a href={`tel:${BRAND.phoneRaw}`} className="flex items-center gap-3 hover:text-[color:var(--vs-blue)]">
                  <Phone className="w-4 h-4 text-[color:var(--vs-blue)]" />
                  <span className="font-display uppercase tracking-tight text-base">{BRAND.phone}</span>
                </a>
              </li>
              <li>
                <a href={`https://wa.me/1${BRAND.whatsappRaw}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[color:var(--vs-blue)]">
                  <MessageCircle className="w-4 h-4 text-[color:var(--vs-blue)]" />
                  <span className="font-display uppercase tracking-tight text-base">{BRAND.whatsapp}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 hover:text-[color:var(--vs-blue)]">
                  <Mail className="w-4 h-4 text-[color:var(--vs-blue)]" />
                  <span className="text-white/85">{BRAND.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[color:var(--vs-blue)] mt-1" />
                <span className="text-white/85 leading-relaxed">
                  {BRAND.areas.join(" · ")}
                  <br />
                  <span className="text-white/60 text-xs">{BRAND.hours}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40">
          <div className="font-mono-accent tracking-[0.25em] uppercase">
            © {new Date().getFullYear()} Vasquez & Son Construction Inc. · All rights reserved.
          </div>
          <div className="font-mono-accent tracking-[0.25em] uppercase">
            Licensed & Insured · Long Island, NY
          </div>
        </div>
      </div>

      {/* Huge display type at bottom */}
      <div className="mt-16 select-none pointer-events-none overflow-hidden">
        <div className="font-display uppercase font-bold tracking-tighter text-[18vw] leading-[0.85] text-center whitespace-nowrap chrome-text opacity-90">
          Vasquez & Son
        </div>
      </div>
    </footer>
  );
}
